import { action } from 'typesafe-actions';
import { GROUP } from '../constants/actions';

export const getList = (payload: any) => action(GROUP.GET_LIST, payload);
export const setList = (payload: any) => action(GROUP.SET_LIST, payload);
export const getRxList = (payload: any) => action(GROUP.GET_RX_LIST, payload);
export const setRxList = (payload: any) => action(GROUP.SET_RX_LIST, payload);
export const getGroupDetails = (payload: any) => action(GROUP.GET_GROUP_DETAILS, payload);
export const setGroupDetails = (payload: any) => action(GROUP.SET_GROUP_DETAILS, payload);
export const updateGroupServiceType = (payload: any) => action(GROUP.UPDATE_GROUP_SERVICE_TYPE, payload);